module.exports = __webpack_public_path__ + "bn.svg?47396a99596dd3b404c803d8811b239e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bn.svg
// module id = 954
// module chunks = 27